<template>
  <gg-modal :is-active="dialog" @close="close">
    <template v-slot:toolbar>Delete Cron Job</template>
    <template v-slot:body>
      <v-row>
        <v-col cols="12">
          <p>Are you sure you wish to <strong>permanently</strong> remove this cron job?</p>
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <gg-btn secondary @click="close" >Cancel</gg-btn>
      <gg-btn primary :loading="loading" @click="deleteJob">Delete</gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DeleteCronJobDialog',
  props: {
    job: {
      required: true,
      type: Object,
    },
    opened: {
      required: true,
      type: Boolean,
    },
  },
  data () {
    return {
      loading: false,
    }
  },
  computed: {
    dialog: {
      get () {
        return this.opened
      },
      set () {
        this.close()
      }
    },
  },
  methods: {
    ...mapActions(['removeCronLine', 'reportSuccess', 'reportError']),
    deleteJob () {
      this.loading = true
      // this.job.count is a line number
      this.removeCronLine({ line: this.job.count, _username: this.$route.query.user, }).then(
        () => {
          this.loading = false
          this.reportSuccess(`Cron job deleted.`)
          this.$emit('job-deleted')
          this.close()
        },
        (error) => {
          this.reportError(error)
          this.loading = false
          this.close()
        }
      )
    },
    close () {
      this.$emit('close')
    },
  },
}
</script>
